export default /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
